module.exports = __webpack_public_path__ + "static/media/icon_dollar.ef4e6a02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_dollar.svg
// module id = 710
// module chunks = 0